import PermissionFilterParameters from "permissions/_api/queries/filtering/permission-filter-parameters";
import PermissionOrderParameters from "permissions/_api/queries/ordering/permission-order-params";
import PaginationParameters from "_shared/_api/queries/pagination/pagination-parameters";

export type PermissionTemplateQueryParams = {
  filterParameters?: PermissionFilterParameters;
  orderParameters?: PermissionOrderParameters;
  paginationParameters?: PaginationParameters;
};

export default class PermissionTemplateQuery {
  public readonly filterParameters?: PermissionFilterParameters;
  public readonly orderParameters?: PermissionOrderParameters;
  public readonly paginationParameters?: PaginationParameters;

  public constructor(params: PermissionTemplateQueryParams) {
    this.filterParameters = params.filterParameters;
    this.orderParameters = params.orderParameters;
    this.paginationParameters = params.paginationParameters;
  }

  public get searchParams(): URLSearchParams {
    return new URLSearchParams([
      ...(this.filterParameters?.searchParams ?? []),
      ...(this.orderParameters?.searchParams ?? []),
      ...(this.paginationParameters?.searchParams ?? []),
    ]);
  }
  public get cacheKey(): string {
    const params = this.searchParams;
    const sortedEntries = [...params.entries()].sort((a, b) => a[0].localeCompare(b[0]));
    return sortedEntries.map(([k, v]) => `${k}=${v}`).join("&");
  }

  public isEqualTo(other: PermissionTemplateQuery | undefined): boolean {
    if (!other) return false;

    const filtersEqual =
      (!this.filterParameters && !other.filterParameters) ||
      (this.filterParameters && other.filterParameters && this.filterParameters.isEqualTo(other.filterParameters));

    const orderEqual =
      (!this.orderParameters && !other.orderParameters) ||
      (this.orderParameters && other.orderParameters && this.orderParameters.isEqualTo(other.orderParameters));

    const paginationEqual =
      (!this.paginationParameters && !other.paginationParameters) ||
      (this.paginationParameters &&
        other.paginationParameters &&
        this.paginationParameters.isEqualTo(other.paginationParameters));

    return Boolean(filtersEqual && orderEqual && paginationEqual);
  }

  public toString(): string {
    return `PermissionQuery {
      Filter Parameters: { ${this.filterParameters?.toString() ?? "None"} }
      Order Parameters: { ${this.orderParameters?.toString() ?? "None"} }
      Pagination Parameters: { ${this.paginationParameters?.toString() ?? "None"} }
    }`;
  }
}
